/* eslint-disable max-lines-per-function */
import React from "react";
import { useMutation, useQuery } from "@apollo/client";
import { Button, Grid } from "@mui/material";
import { PropertyUseCaseInput, getPropertyUseCases, upsertPropertyUseCase } from "types/gql-types";
import { LoadingSpinner, ServerError } from "components/graphql-views";
import { useSnackbar } from "components/haven-design/snackbar";
import { AdminHeading } from "../../shared/admin-form";
import UseCaseItem from "./use-case-item";
import UseCaseModal from "./use-case-modal";
import { PROPERTY, UPDATE_PROP_USE_CASES } from "./queries";
import { PropertyUseCaseType } from "./use-case-form";


type Props = {
  propertyId?: string;
}

const PropertyUseCases:React.FC<Props> = ({ propertyId }) => {
  const { openSnackbar } = useSnackbar();
  const [open, setOpen] = React.useState(false);
  const [editItem, setEditItem] = React.useState<PropertyUseCaseType | null>(null);
  const { error, loading, data, refetch } = useQuery<getPropertyUseCases>(PROPERTY, {
    variables: { id: propertyId },
    fetchPolicy: "cache-and-network",
  });

  const [upsert] = useMutation<upsertPropertyUseCase>(UPDATE_PROP_USE_CASES);

  const upsertUseCase = (input: PropertyUseCaseInput) => {
    upsert({ variables: { data: {
      active: input.active,
      messageId: input.messageId,
      propertyId: input.propertyId,
      smsPrefix: input.smsPrefix,
      useCaseId: input.useCaseId,
      applicationId: input.applicationId,
    } } })
      .then(() => {
        openSnackbar({ message: "Use case successfully updated", status: "success" });
        refetch();
        setOpen(false);
      });
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ServerError desc={error.message} />;
  if (!data) return <ServerError desc="Missing Data" />;

  return (<Grid container spacing={2}>
    <Grid container size={{ xs: 8 }}>
      <AdminHeading>{data.property.name}</AdminHeading>
    </Grid>
    <Grid container size={{ xs: 4 }} justifyContent="flex-end">
      <Button
        size="large" color="primary" variant="contained" onClick={() => {
          setEditItem(null);
          setOpen(true);
        }}
        disabled={loading}
      >
        Add Use Case
      </Button>
    </Grid>
    {data.property.propertyUseCases.map((useCase) => <Grid key={useCase.id} size={{ xs: 12 }}>
      <UseCaseItem
        useCase={useCase}
        openEdit={() => {
          setEditItem(useCase);
          setOpen(true);
        }} />
    </Grid>)}
    <UseCaseModal
      useCases={data.getUseCases}
      subaccounts={data.getActiveSubaccounts}
      onSubmit={upsertUseCase}
      open={open}
      onClose={() => setOpen(false)}
      property={data.property}
      editItem={editItem}
    />
  </Grid>);
};

export default PropertyUseCases;
